import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/new_coupon",
  component: function component() {
    return import("../../../views/new_coupon/new_coupon_index.vue");
  },
  name: "new_coupon",
  meta: {
    foot: true,
    title: "我的优惠券"
  }
}, {
  path: "/new_coupon/carNumber/:id/:orderGoodsId?",
  component: function component() {
    return import("../../../views/new_coupon/carNumber.vue");
  },
  name: "carNumber",
  meta: {
    foot: true,
    title: "选择车牌号"
  }
}, {
  path: "/new_coupon/exchange",
  component: function component() {
    return import("../../../views/new_coupon/exchange.vue");
  },
  name: "new_coupon_exchange",
  meta: {
    foot: true,
    title: "兑换"
  }
}, {
  path: "/new_coupon/exchange/record",
  component: function component() {
    return import("../../../views/new_coupon/exchange_record.vue");
  },
  name: "new_coupon_exchange_record",
  meta: {
    foot: true,
    title: "兑换记录"
  }
}, {
  path: "/new_coupon_detail/:id",
  component: function component() {
    return import("../../../views/new_coupon/new_coupon_detail.vue");
  },
  name: "new_coupon_detail",
  meta: {
    foot: true,
    title: "优惠券详情"
  }
}, {
  path: "/new_coupon_detail/combination/:id",
  component: function component() {
    return import("../../../views/new_coupon/new_coupon_detail.vue");
  },
  name: "new_coupon_detail_combination",
  meta: {
    foot: true,
    title: "优惠券详情"
  }
}, {
  path: "/new_CouponShareShow/:mark_id",
  component: function component() {
    return import("../../../views/coupon/shareShow.vue");
  },
  name: "new_CouponShareShow",
  meta: {
    foot: true,
    title: "优惠券"
  }
}, {
  path: "/new_Coupon/shareGet",
  component: function component() {
    return import("../../../views/coupon/shareGet.vue");
  },
  name: "new_CouponShareGet",
  meta: {
    foot: true,
    title: "优惠券"
  }
}, {
  path: "/new_Coupon/checkList",
  component: function component() {
    return import("../../../views/coupon/checkList.vue");
  },
  name: "new_CouponCheckList",
  meta: {
    foot: true,
    title: "优惠券核销"
  }
}, {
  path: "/new_Coupon/combination/:id",
  component: function component() {
    return import("../../../views/new_coupon/combination.vue");
  },
  name: "new_CouponCombination",
  meta: {
    foot: true,
    title: "组合券"
  }
}, {
  path: "/new_Coupon/combinationDetail/:id",
  component: function component() {
    return import("../../../views/new_coupon/combinationDetail.vue");
  },
  name: "new_CouponCombinationDetail",
  meta: {
    foot: true,
    title: "组合券"
  }
}, {
  path: "/flashSaleOrderpay/:order_ids",
  component: function component() {
    return import("../../../views/member/order/order_payment.vue");
  },
  name: "flashSaleOrderpay",
  meta: {
    foot: true,
    title: "订单支付"
  }
}];